'use client'

import { create } from 'zustand'

interface IDatadogStore {
  isInitialized: boolean
  setIsInitialized: (isInitialized: boolean) => void
}

export const useDatadogStore = create<IDatadogStore>((set) => ({
  isInitialized: false,

  // setters
  setIsInitialized: (isInitialized) => set({ isInitialized }),
}))
